(function () { 
    angular.module('invesfleet')
        .directive('daterange', daterange);
    
        daterange.$inject = ['$filter'];
    
        function daterange($filter) {
            
            return {
                restrict: 'EA',
                templateUrl: 'app/views/directives/dateRange.html',
                scope: {
                    dateFrom: '=',
                    dateTo: '=',
                    maxRange: '=?',
                    onChange: '&?',
                    seconds: '<?',
                    ngDisabled: '=?',
                    autofocus: '<?',
                    autoInit: '<?',
                    allowFuture: '<?'
                }, 
                link: function(scope, element, attrs){
                    
                    if(typeof scope.seconds === 'undefined'){ scope.seconds = true; } 
                    if(typeof scope.allowFuture === 'undefined'){ scope.allowFuture = true; } 
                    if (!scope.autofocus) { scope.autofocus = false; } else {
                        //console.log('autofocus true'); 
                        scope.autofocus = true;
                    }
    
                    scope.minFrom = null;
                    scope.maxFrom = null;
                    scope.minTo = null;
                    scope.maxTo = null;

                    //INICIALIZAR CON FECHA ACTUAL
                    if (scope.autoInit) {
                        scope.dateFrom = Date.NewDate();
                        scope.dateFrom.setDate(scope.dateFrom.getDate() - 1);
                        scope.dateTo = Date.NewDate();
                        
                        setDatesLimits();
                    }
                    
                    scope.ngChange = function(){
                        setDatesLimits();
                        if(scope.onChange){ scope.onChange(); }
                    }; 

                    function setDatesLimits(){
                        if(scope.dateFrom){
                            scope.minTo = new Date(scope.dateFrom);
                            scope.minTo.setDate(scope.minTo.getDate() + 1);
                            scope.maxTo = new Date(scope.dateFrom);
                            scope.maxTo.setDate(scope.maxTo.getDate() + scope.maxRange);

                            if(!scope.allowFuture && scope.minTo > Date.NewDate()){ scope.minTo = Date.NewDate(); }
                            if(!scope.allowFuture && scope.maxTo > Date.NewDate()){ scope.maxTo = Date.NewDate(); }

                            scope.minTo =  formatDateForHTML5(scope.minTo);
                            scope.maxTo =  formatDateForHTML5(scope.maxTo);
                        }
                        if(scope.dateTo){
                            scope.maxFrom = new Date(scope.dateTo);
                            scope.maxFrom.setDate(scope.maxFrom.getDate() - 1);
                            scope.minFrom = new Date(scope.dateTo);
                            scope.minFrom.setDate(scope.minFrom.getDate() - scope.maxRange);

                            if(!scope.allowFuture && scope.minFrom > Date.NewDate()){ scope.minFrom = Date.NewDate(); }
                            if(!scope.allowFuture && scope.maxFrom > Date.NewDate()){ scope.maxFrom = Date.NewDate(); }

                            scope.maxFrom =  formatDateForHTML5(scope.maxFrom);
                            scope.minFrom =  formatDateForHTML5(scope.minFrom);
                        }
                    }

                    function formatDateForHTML5(date) {
                        return $filter('date')(date, 'yyyy-MM-ddTHH:mm');
                    }
                }
            };
        }
    })();